import { Video } from "./Video";

export const VideoPlayerSection = ({ 
  appliedFilters, 
  isPlaying, 
  setIsPlaying,
  currentTime,
  setCurrentTime,
  duration,
  selectedVideo,
  getFileUrl,
  videoRef,
  videoLoading
}) => {
  return (
    <div className="min-h-0 overflow-hidden">
      <div className="h-full rounded-lg shadow-lg bg-black flex items-center justify-center relative">
        {/* Loading overlay */}
        <div
          className={`absolute inset-0 bg-black z-10 flex items-center justify-center transition-opacity duration-300 ${
            videoLoading ? "opacity-50" : "opacity-0 pointer-events-none"
          }`}
        >
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
        </div>
        
        {/* Video player */}
        <div className={`w-full h-full relative transition-opacity duration-300 ${
          videoLoading ? "opacity-0" : "opacity-100"
        }`}>
          <Video
            appliedFilters={appliedFilters}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
            currentTime={currentTime}
            setCurrentTime={setCurrentTime}
            duration={duration}
            selectedVideo={selectedVideo}
            getFileUrl={getFileUrl}
            ref={videoRef}
          />
        </div>
      </div>
    </div>
  );
};
